/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowWaveLeftDown = createReactComponent("outline", "arrow-wave-left-down", "IconArrowWaveLeftDown", [["path", { "d": "M7 14h-4v-4", "key": "svg-0" }], ["path", { "d": "M21 12c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2", "key": "svg-1" }]]);

export { IconArrowWaveLeftDown as default };
//# sourceMappingURL=IconArrowWaveLeftDown.mjs.map
